import AOS from 'aos';
import { CountUp } from 'countup.js';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

document.addEventListener("DOMContentLoaded", function () {
  //Main Nav toggle
  const nav = document.querySelector("#mobile-nav");
  const header = document.querySelector(".main-header");
  const opener = document.querySelector(".mobile-nav-opener");

  opener.addEventListener("click", function (event) {
    
    event.preventDefault();

    header.classList.toggle("nav-open");
    nav.classList.toggle("active");

  });

});


document.addEventListener("DOMContentLoaded", function () {
  //Main Nav toggle
  const search = document.querySelector("#main-search-wrapper");
  const opener = document.querySelector(".main-search-open");
  const mobopener = document.querySelector(".mobile-search-open"); 
  const closer = document.querySelector(".main-search-close");

  opener.addEventListener("click", function (event) {
    
    event.preventDefault();
    search.classList.toggle("active");

    document.getElementById("search-field").focus();

  });

  mobopener.addEventListener("click", function (event) {
    
    event.preventDefault();
    search.classList.toggle("active");

    document.getElementById("search-field").focus();

  });

  closer.addEventListener("click", function (event) {
    
    event.preventDefault();
    search.classList.toggle("active");

  });

});




/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(document).foundation(); // Foundation JavaScript

        AOS.init({
          duration: 1000,
          once: true,
        },
          console.log('AOS loaded')
        );


        if (document.querySelector('.countup-animated-number')) {
          const animatedNumbers = document.querySelectorAll('.countup-animated-number .number-span');
        
          animatedNumbers.forEach((element) => {
            let targetNumber = parseInt(element.getAttribute('data-target'), 10);
            let delayMs = parseInt(element.getAttribute('data-delay'), 10);
            let startVal = parseInt(element.getAttribute('data-start'), 10) || 0;
        
            let countUp = new CountUp(element, targetNumber, {
              duration: 2,
              separator: ',',
              enableScrollSpy: true,
              scrollSpyOnce: true,
              scrollSpyDelay: delayMs,
              startVal: startVal,
            });
        
            if (countUp.error) {
              console.error(countUp.error);
            }
            console.log('CountUpJS loaded')
          });
        }

        // Product Filter Grid (flexible/section_product_filter_grid.php):
        // Isotope grid filtered by the sidebar category buttons.
        document.querySelectorAll('.product-filter-grid').forEach(function (section) {
          var grid = section.querySelector('.pfg-grid');
          if (!grid) { return; }

          var iso = new Isotope(grid, {
            itemSelector: '.pfg-item',
            layoutMode: 'fitRows',
            percentPosition: true,
            transitionDuration: 0,
          });

          // Isotope absolutely-positions items at their natural height, so
          // .product-card's height:100% has nothing to resolve against and cards end
          // ragged. Stretch each currently-visible card to the tallest card in its
          // own row (like Foundation's equalize-by-row), so rows are uniform without
          // one long card inflating the whole grid. Full-width category labels are
          // excluded — they're their own row and must keep their natural height.
          var pendingEqualize = false;

          var equalizeCards = function () {
            // Coalesce bursts (a filter click can trigger several callers) and, more
            // importantly, defer past the current frame: iso.arrange() reveals items
            // that were display:none, and measuring before the browser has applied
            // that would read a height of 0.
            if (pendingEqualize) { return; }
            pendingEqualize = true;

            requestAnimationFrame(function () {
              pendingEqualize = false;

              // Clear EVERY item, not just the visible ones. An item hidden by the
              // previous filter keeps whatever height it was last given; when it
              // comes back it would be measured at that stale height instead of its
              // natural one, and the grid ratchets taller each time.
              iso.getItemElements().forEach(function (el) {
                el.style.height = '';
              });

              // re-position at natural heights first: fitRows gives every item in a
              // row the same y, which is how rows are identified below
              iso.layout();

              var cards = iso.getFilteredItemElements().filter(function (el) {
                return !el.classList.contains('pfg-category-label');
              });

              if (!cards.length) { return; }

              // measure every card (position + natural height) before writing any,
              // so the reads don't interleave with writes and thrash layout
              var rows = {};
              cards.forEach(function (el) {
                var rect = el.getBoundingClientRect();
                var key = Math.round(rect.top);
                if (!rows[key]) { rows[key] = { els: [], tallest: 0 }; }
                rows[key].els.push(el);
                rows[key].tallest = Math.max(rows[key].tallest, rect.height);
              });

              Object.keys(rows).forEach(function (key) {
                var row = rows[key];
                if (!row.tallest) { return; }
                row.els.forEach(function (el) {
                  el.style.height = row.tallest + 'px';
                });
              });

              // heights just changed, so Isotope's row positions are stale
              iso.layout();
            });
          };

          equalizeCards();

          // re-layout as card images load in
          imagesLoaded(grid).on('progress', function () {
            iso.layout();
          }).on('always', function () {
            equalizeCards();
          });

          // The cards carry an inline SVG and no <img>, so imagesLoaded resolves
          // immediately — before webfonts swap in. Titles and descriptions rewrap at
          // that point, so measurements taken earlier are stale. Re-run once fonts
          // settle, which is the last thing that changes card height on load.
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(equalizeCards);
          }

          // column count changes at the 500px/medium breakpoints, so cards get
          // narrower or wider, text rewraps, and the tallest card changes
          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(equalizeCards, 150);
          });

          section.querySelectorAll('.pfg-filter').forEach(function (button) {
            button.addEventListener('click', function () {
              section.querySelectorAll('.pfg-filter').forEach(function (b) {
                b.classList.remove('is-active');
              });
              button.classList.add('is-active');
              iso.arrange({ filter: button.dataset.filter });

              // keep the URL linkable: ?filter={slug}, no param for "Show All".
              // replaceState so filter clicks don't pile up in back-button history.
              var url = new URL(window.location.href);
              if (button.dataset.filter === '*') {
                url.searchParams.delete('filter');
              } else {
                url.searchParams.set('filter', button.dataset.filter.replace(/^\.pcat-/, ''));
              }
              history.replaceState(null, '', url);
            });
          });

          // apply a filter arriving via ?filter={slug}; unknown slugs are ignored.
          // Matched by comparing dataset values, not by interpolating the param
          // into a selector, so arbitrary query strings can't break anything.
          var initialFilter = new URLSearchParams(window.location.search).get('filter');
          if (initialFilter) {
            section.querySelectorAll('.pfg-filter').forEach(function (button) {
              if (button.dataset.filter === '.pcat-' + initialFilter) {
                button.click();
              }
            });
          }
        });

        // Flexible-content accordions (.fc-section-accordion-*): custom markup,
        // not Foundation's data-accordion — .current toggles a CSS grid-rows transition.
        $('.accordion .accordion-topic').on('click', function () {
          var $topic = $(this);
          var $item = $topic.closest('.accordion-item');

          $topic.toggleClass('current');
          $topic.next('.accordion-response').toggleClass('current');

          // Close any other open items in the same accordion
          $item.siblings('.accordion-item').find('.accordion-topic').removeClass('current');
          $item.siblings('.accordion-item').find('.accordion-response.current').removeClass('current');
        });

        $('.carousel-wrapper').each(function() {
          var $this = $(this);
          var $slidesToShow = $this.data('slides-to-show');
          var $duration = $this.data('duration');
      
          console.log('Slides to show: ' + $slidesToShow);
          console.log('Duration: ' + $duration);
      
          $this.slick({
            infinite: true,
            slidesToShow: $slidesToShow,
            duration: $duration,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<button type="button" class="slick-prev cards-next"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="41" viewBox="0 0 23 41" fill="none"> <path d="M21.123 1.5L2.12129 20.5018L21.123 39.5035" stroke="#062F6E" stroke-width="3" stroke-linecap="round"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next cards-prev"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="41" viewBox="0 0 23 41" fill="none"><path d="M1.5 39.5034L20.5018 20.5017L1.5 1.4999" stroke="#062F6E" stroke-width="3" stroke-linecap="round"/></svg></button>',
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                }
              },
            ]
          });
        });



        if (document.querySelector('.flexible-image-map')) {
          const imageMaps = document.querySelectorAll('.flexible-image-map');
        
          imageMaps.forEach((element) => {

            const markers = element.querySelectorAll('.marker');
            const markerTexts = element.querySelectorAll('.marker-text');

            const clearAll = () => {
              markers.forEach((m) => m.classList.remove('active'));
              markerTexts.forEach((mt) => mt.classList.remove('active'));
            };

            // Each .marker carries data-marker="#marker_N" pointing at its .marker-text.
            // Hovering either half of the pair highlights both.
            markers.forEach((marker) => {
              const targetId = marker.getAttribute('data-marker');
              const markerText = targetId ? element.querySelector(targetId) : null;
              if (!markerText) return;

              const pair = [marker, markerText];

              pair.forEach((el) => {
                el.addEventListener('mouseenter', () => {
                  clearAll();
                  pair.forEach((p) => p.classList.add('active'));
                });
                el.addEventListener('mouseleave', () => {
                  pair.forEach((p) => p.classList.remove('active'));
                });
              });
            });

          });


        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $('.about-navigation .submenu li.active').closest('.has-submenu').removeClass('active');
        //$('.primary-navigation .submenu li.active').closest('.has-submenu').removeClass('active');

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        
        $('.featured-products').slick({
          infinite: true,
          slidesToShow: 3,
          cssEase: 'linear',
          autoplay: false,
          arrows: true,
          swipeToSlide: true,
          touchThreshold: 50,
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]

        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'how_to_buy': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        
        // Form 2 filters the contact cards client-side and must never actually
        // submit. Gravity Forms attaches its own submit handler and puts an
        // inline onclick on the button, so preventDefault() alone is not
        // enough -- strip the inline handler and block the submit event too.
        // gform_post_render fires again if GF re-renders the form.
        var disableGfSubmit = function() {
          $('#gform_2').find('[type="submit"]').removeAttr('onclick');
        };

        disableGfSubmit();
        $(document).on('gform_post_render', disableGfSubmit);
        $(document).on('submit', '#gform_2', function(event) {
          event.preventDefault();
        });

        // GF now renders the submit control as <button type="submit"> rather
        // than <input type="submit">, which is why the old selector matched
        // nothing. a.button is the styled "Continue" in the form's HTML field.
        $(document).on('click', '#gform_2 [type="submit"], #gform_2 a.button', function(event) {

          event.preventDefault();

          var product_name = $("#input_2_1 option:selected").text();
          var region_name = $("#input_2_3 option:selected").text();

          var product = $('#input_2_1').val();
          var region = $('#input_2_3').val();
          var state = $('#input_2_4').val();



          console.log(state);
          
          if (state) {

            state = state.toLowerCase().replace(/ /g, '-');

            console.log(state);

            var results = '.' + product + '.' + region + '.' + state;

          } else {

            var results = '.' + product + '.' + region;

          }

          console.log(results);

          $('#input_3_11').val(product_name);
          $('#results-region').html(region_name);
          $('#results-product-type').html(product_name);
          
          $('.how-to-buy-cell').hide();

          if ( $(results).length ) {
            
            $(results).show();      

          } else {
            
            $('.no-results').show();  

          }
          
          $('.how-to-buy-results').show();
          
          $('.how-to-buy-form').show();      

          $('html,body').animate({
             scrollTop: $('.how-to-buy-results').offset().top
          });

        });

      }
    },
    'single_product': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        
        $('.gallery-nav--item').click(function(e){

          $('.gallery-nav--item').removeClass('active');

          $(this).addClass('active');

          e.preventDefault();
          var img = $(this).data('view');
          $('.gallery-view img').attr('src', img);

        });

      }
    },
    'resources': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        //Resource filter dropdown / children categories
        $("li.resource-link.has-children i").on("click", function () {
          $(this).parent("li").toggleClass("is-open");
          $(this).parent("li").children("ul").slideToggle();
        });

        //Open sub cat menu if child is selected onload
        $(document).ready(function () {
          const activeLi = $("li.resource-link.has-children li.active");
          if (activeLi) {
            activeLi.parent("ul.children").css("display", "block");
            activeLi
              .parent("ul.children")
              .parent("li.resource-link.has-children")
              .addClass("is-open");
          }
        });   
      }
    },

    'post_type_archive_product': {
      init: function() {
        
        $('.page-header-slider').slick({
          infinite: true,
          cssEase: 'linear',
          autoplay: true,
          arrows: false,
          dots: false,
          fade: true,
          speed: 1000
        });

      }
    },
    'tax_product_category': {
      init: function() {
        
        $( '.tabs-panel' ).each(function( index ) {
          
          var tab = $(this).attr('id');
          
          console.log(tab);

          var tabLength = $('#' + tab + ' .categories').children('.category').length;

          $('.tab-count-' + tab).html('(' + tabLength + ')');
        
        });

      }

    },
    'careers': {
      init: function() {    
        var element = $('#gnewtonCareerBody').detach();
        $('#job-openings .flexible-cell').append(element);
      }

    },
    'postid_513': {
      init: function() {    

        var hotspots = $('.hotspot');
        hotspots.each(function() {
          $(this).on('click', function(){
            if( $('.is-focused')[0] !== $(this)[0] ){
              $('.is-focused').removeClass('is-focused');
            }
            
            $(this).toggleClass('is-focused');
          });

        });

      }

    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.










/*

$('.gallery').each(function( index ) {
  var gallery = $(this).attr('id');
  var lightbox = $('#' + gallery + ' a').simpleLightbox({});
});

//Simple Lightbox - Already Installed
var lightbox = $('.gallery-gallery a').simpleLightbox();

// Slick Slideshow - Already Installed
$('.home-slideshow').slick({
  infinite: true,
  cssEase: 'linear',
  autoplay: true,
  arrows: true,
  dots: true
});

// Smooth Scroll
var topOffset = 0;
$(".scroll-to, .scroll-to-li a").not('[href="#"]').not('[href="#0"]').click(function(t){if(location.pathname.replace(/^\//,"")===this.pathname.replace(/^\//,"")&&location.hostname===this.hostname){var e=$(this.hash);(e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({scrollTop:e.offset().top-topOffset},1e3,function(){var t=$(e);if(t.focus(),t.is(":focus"))return!1;t.attr("tabindex","-1"),t.focus()}))}});

*/
